<template>
  <div>
    <div class="css-grid pay-invoice-form__row pay-invoice-form__row--header">
      <div></div>
      <div class="pay-invoice-view__cell pay-invoice-view__cell--header">Payment Info</div>
      <div></div>
    </div>
    <div class="panel">
      <div class="css-grid pay-invoice-form__row">
        <div class="h-collapsible"></div>
        <div>
          <div class="grid__col--6">
            <div class="form__item--row">
              <StoreConnectedInput store="payInvoice" name="invoiceNumber" :debounce="false" placeholder="Invoice Number *"></StoreConnectedInput>
            </div>
          </div>
          <div class="grid__col--6">
            <div class="form__item--row">
              <StoreConnectedInputGroup store="payInvoice" name="amount" icon="usd" :debounce="false" placeholder="Payment Amount *"></StoreConnectedInputGroup>
            </div>
          </div>
        </div>
        <div class="h-collapsible"></div>
      </div>
    </div>
    <div class="css-grid pay-invoice-form__row pay-invoice-form__row--header">
      <div class="h-collapsible"></div>
      <div class="pay-invoice-view__cell pay-invoice-view__cell--header">Billing Info</div>
      <div class="h-collapsible"></div>
    </div>

    <div class="panel">
      <CreditCardForm></CreditCardForm>
    </div>

    <div class="pay-invoice__nav-row h-center-align">
      <button class="btn btn-primary" @click.prevent="nextStep" :disabled="!formValid">Submit Payment</button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import StoreConnectedSelect from '../form-items/StoreConnectedSelect.vue';
  import StoreConnectedInput from '../form-items/StoreConnectedInput.vue'
  import StoreConnectedInputGroup from '../form-items/StoreConnectedInputGroup.vue'
  import CreditCardForm from './payment/CreditCardForm.vue';

  export default {
    name: 'PaymentView',
    components: {
      StoreConnectedInput,
      StoreConnectedInputGroup,
      StoreConnectedSelect,
      CreditCardForm,
    },
    data() {
      return {
        store: 'payInvoice',
      };
    },
    computed: {
      ...mapGetters('payInvoice', ['paymentInfo', 'invoiceNumber', 'paymentAmount']),
      cardNumber() {
        return this.paymentInfo.cardNumber;
      },
      cardNumberValid() {
        return this.cardNumber !== null && this.cardNumber !== '';
      },
      cardholderName() {
        return this.paymentInfo.cardholderName;
      },
      cardholderNameValid() {
        return this.cardholderName !== null && this.cardholderName !== '';
      },
      expDate() {
        return this.paymentInfo.expDate;
      },
      expDateValid() {
        return this.expDate !== null && this.expDate !== '';
      },
      cvv() {
        return this.paymentInfo.cvv;
      },
      cvvValid() {
        return this.cvv !== null && this.cvv !== '';
      },
      invoiceNumberValid() {
        return this.invoiceNumber !== null && this.invoiceNumber !== '';
      },
      paymentAmountValid() {
        return this.paymentAmount !== null && this.paymentAmount !== '' && this.paymentAmount > 0;
      },
      formValid() {
        return this.cardNumberValid &&
            this.cardholderNameValid &&
            this.expDateValid &&
            this.cvvValid &&
            this.invoiceNumberValid &&
            this.paymentAmountValid;
      },
    },
    methods: {
      nextStep() {
        this.$store.dispatch('payInvoice/submitPayment');
      },
    },
  };
</script>
